import { Validator } from "vee-validate";

const validator = new Validator();
validator.attach("email", "email"); // attach field.

export const notEmail = {
  getMessage: field => "This " + field + " can't be an E-mail address.",
  validate: value => {
    return validator.validate("email", value).then(result => {
      return {
        valid: !result
      };
    });
  }
};
